/*----- Core -----*/
import React 			 from 'react'
import PropTypes 	 from 'prop-types'
import styled 		 from 'styled-components'
import { css } 		 from 'styled-components'

/*----- Commons-----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color 			from '../../commons/Color'

/*----- Components -----*/

/*----- Styles-----*/
const StyledLabelButton = styled.label`
	${ Montserrat(14, 600, Color.main) };
	text-transform: capitalize;
	height: 36px;
	border-radius: 4px;
	padding: 0 20px;
	cursor: pointer;
	background: ${Color.main};
	min-width: 115px;
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 200px;
	border: none;
	transition: all 0.5s;
	&:focus {
		outline: none;
	}
	&:hover {
		color: white;
		box-shadow: 0 8px 16px 0px rgba(0,0,0, 0.2);
	}
	${props => props.invert && css`
		background: none;
		border: 1px solid ${ Color.grey };
		color: ${ Color.grey };
		&:hover {
			color: ${ Color.main };
			box-shadow: none;
			border-color: ${ Color.main };
		}
  `}
`

/*----- Component -----*/
const LabelButton = ({ htmlFor, content, invert }) => (
	<StyledLabelButton className="default-button" htmlFor={htmlFor} invert={invert? 1 : 0}>
		{ content }
	</StyledLabelButton>
)
export default LabelButton

/*----- PropTypes -----*/
LabelButton.propTypes = {
	content: 		PropTypes.string.isRequired,
	htmlFor: PropTypes.string.isRequired
}
